import React from 'react';

const ConsentContext = React.createContext({});

export const ConsentProvider = ConsentContext.Provider;

export default ConsentContext;
